// Shared Fieldbook header. Render inside a `.ffly .ffly--public` wrapper.
import "./field-chrome.css";

type NavKey = "tools" | "docs" | "pricing" | "blog";

export default function FieldHeader({
  active,
  sticky = false,
  wide = false,
}: {
  active?: NavKey;
  sticky?: boolean;
  wide?: boolean;
}) {
  return (
    <header className={`ffly-hdr${sticky ? " ffly-hdr--sticky" : ""}${wide ? " ffly-hdr--wide" : ""}`}>
      <div className="ffly-hdr-inner">
        <a href="/" className="brand" aria-label="FHIRfly home">
          <img className="logo" src="/logo-horiz-color-transparent.png" alt="FHIRfly" />
        </a>
        <nav>
          <a href="/tools" className={active === "tools" ? "on" : undefined}>Tools</a>
          <a href="/docs" className={active === "docs" ? "on" : undefined}>Docs</a>
          <a href="/pricing" className={active === "pricing" ? "on" : undefined}>Pricing</a>
          <a href="/blog" className={active === "blog" ? "on" : undefined}>Blog</a>
          <a href="/dashboard" className="signin">Sign in</a>
        </nav>
      </div>
    </header>
  );
}
